import { render, staticRenderFns } from "./BtnBlob.vue?vue&type=template&id=04e73c48&scoped=true"
import script from "./BtnBlob.vue?vue&type=script&lang=js"
export * from "./BtnBlob.vue?vue&type=script&lang=js"
import style0 from "./BtnBlob.vue?vue&type=style&index=0&id=04e73c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e73c48",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
